import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from '../store/store';
import useStatusFinderByNum from './useStatusFinderByNum';
import useRequestTypeFinderById from './useRequestTypeFinderById';
import useFindCountryTypeByType from './useFindCountryTypeByType';
import { useRequisitionInfoExistingReq } from './useRequisitionInfoExistingReq';
import useDeptProjectName from './useDeptProjectName';
import useWorkLocationType from './useWorkLocationType';
import useResizeLayout from './useResizeLayout';
import useNavigationToListRequests from './useNavigationToListRequests';
import useLeaveTypeTitleFinderById from './useLeaveTypeTitleFinderById';
import useNotification from './useNotification';
import useStickyHeader from './useStickyHeader';
import useShowScrollButton from './useShowScrollButton';
import useAppsMenuConfig from './useAppsMenuConfig';
import useRoutePrefix from './useRoutePrefix';
import useRequestFromPage from './useRequestFromPage';
import useDebounce from './useDebounce';
import useAuthUserWithToken from './useAuthUserWithToken';
import useLogout from './useLogout';
import useWasRefreshedPage from './useWasRefreshedPage';
import useUserPermissions from './useUserPermissions';
import useAuthRenewal from './useAuthRenewal';
import useIsLoadedConent from './useIsLoadedConent';
import useRequestRefetcher from './useRequestRefetcher';
import useUserCollector from './useUserCollector';
import useFindRequestType from './useFindRequestType';
import useReassignUsersManager from './useReassignUsersManager';
import useHasAccessToSubmit from './useHasAccessToSubmit';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export {
  useHasAccessToSubmit,
  useUserCollector,
  useRequestRefetcher,
  useWasRefreshedPage,
  useAuthUserWithToken,
  useAuthRenewal,
  useLogout,
  useShowScrollButton,
  useStickyHeader,
  useStatusFinderByNum,
  useRequestTypeFinderById,
  useFindCountryTypeByType,
  useRequisitionInfoExistingReq,
  useDeptProjectName,
  useWorkLocationType,
  useResizeLayout,
  useNavigationToListRequests,
  useLeaveTypeTitleFinderById,
  useNotification,
  useAppsMenuConfig,
  useRoutePrefix,
  useRequestFromPage,
  useDebounce,
  useUserPermissions,
  useIsLoadedConent,
  useFindRequestType,
  useReassignUsersManager,
};
